<br />
<span class="risk-level-explain-label"></span><br />

<div class="risk-level-explain">
  <div [class]="cssClass"></div>
  <span class="risk-level-text">{{ riskTitle | translate }}</span
  ><br />
  <span [class]="cssClassPercent">{{ percentage }}%</span><br />
</div>
